// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
    font-family: Montserrat, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 400;
    border-radius: .25rem;
    background-color: #fff;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, .15);
    transition: box-shadow .25s ease-in-out;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    max-width: 30rem;
    border: 0
  }

  .card:hover {
    box-shadow: 2px 6px 12px 0 rgba(0, 0, 0, .25)
  }

  .card:focus-within {
    outline: 3px solid #0085b3;
    outline-offset: 0;
    outline-offset: 3px
  }

  .card:focus-within .card__link {
    text-decoration: none
  }

  .card__title {
    font-family: Montserrat, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 600;
    font-size: 1.125rem;
    line-height: 1.25;
    margin: 0 0 .75rem
  }

  @media (min-width:62em) {
    .card__title {
      font-size: 1.25rem
    }
  }

  .card__content {
    font-size: 1rem;
    line-height: 1.25;
    padding: 1rem 1rem 4rem;
    border-top: 6px solid #47888E;
    display: flex;
    flex-direction: column;
    order: 2
  }

  @media (min-width:62em) {
    .card__content {
      font-size: 1rem;
      padding: 1rem 2rem 4rem
    }
  }

  .card__content p {
    margin: 0 0 .75rem
  }

  .card__tag {
    font-family: Montserrat, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 600;
    order: 1
  }

  .card__date {
    order: 2
  }

  .card__date, .card__tag {
    font-size: .875rem;
    line-height: 1.25
  }

  @media (min-width:62em) {
    .card__date, .card__tag {
      font-size: .875rem
    }
  }

  .card__copy, .card__icon, .card__title {
    order: 3
  }

  .card__icon {
    margin: 1rem 0 0;
    bottom: 1rem;
    position: absolute;
    width: 1rem;
    height: 1rem
  }

  @media (min-width:48em) {
    .card__icon {
      width: 1.25rem;
      height: 1.25rem
    }
  }

  .card__link {
    text-decoration: none;
    color: #002664
  }

  .card__link:after {
    z-index: 100;
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0
  }

  .card__link:focus, .card__link:hover {
    text-decoration: underline
  }

  .card__link:focus {
    outline: none
  }

  .card__image-area {
    order: 1;
    height: 12.5rem;
    overflow: hidden;
  }

  .card__image {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    height: 100%;
    /*object-fit: contain;*/
  }

  .card--headline .card__title {
    font-size: 1.625rem;
    line-height: 1.25
  }

  @media (min-width:62em) {
    .card--headline .card__title {
      font-size: 1.75rem
    }
  }
`, "",{"version":3,"sources":["webpack://./src/app/uilib/card/card.component.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,mCAAmC;IACnC,kCAAkC;IAClC,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,2CAA2C;IAC3C,uCAAuC;IACvC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB;EACF;;EAEA;IACE;EACF;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB;EACF;;EAEA;IACE;EACF;;EAEA;IACE,0CAA0C;IAC1C,mCAAmC;IACnC,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;EACF;;EAEA;IACE;MACE;IACF;EACF;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB;EACF;;EAEA;IACE;MACE,eAAe;MACf;IACF;EACF;;EAEA;IACE;EACF;;EAEA;IACE,0CAA0C;IAC1C,mCAAmC;IACnC,kCAAkC;IAClC,gBAAgB;IAChB;EACF;;EAEA;IACE;EACF;;EAEA;IACE,kBAAkB;IAClB;EACF;;EAEA;IACE;MACE;IACF;EACF;;EAEA;IACE;EACF;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX;EACF;;EAEA;IACE;MACE,cAAc;MACd;IACF;EACF;;EAEA;IACE,qBAAqB;IACrB;EACF;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB;EACF;;EAEA;IACE;MACE;IACF;EACF","sourcesContent":[".card {\r\n    font-family: Montserrat, Arial, sans-serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    font-weight: 400;\r\n    border-radius: .25rem;\r\n    background-color: #fff;\r\n    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, .15);\r\n    transition: box-shadow .25s ease-in-out;\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    height: 100%;\r\n    max-width: 30rem;\r\n    border: 0\r\n  }\r\n\r\n  .card:hover {\r\n    box-shadow: 2px 6px 12px 0 rgba(0, 0, 0, .25)\r\n  }\r\n\r\n  .card:focus-within {\r\n    outline: 3px solid #0085b3;\r\n    outline-offset: 0;\r\n    outline-offset: 3px\r\n  }\r\n\r\n  .card:focus-within .card__link {\r\n    text-decoration: none\r\n  }\r\n\r\n  .card__title {\r\n    font-family: Montserrat, Arial, sans-serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    font-weight: 600;\r\n    font-size: 1.125rem;\r\n    line-height: 1.25;\r\n    margin: 0 0 .75rem\r\n  }\r\n\r\n  @media (min-width:62em) {\r\n    .card__title {\r\n      font-size: 1.25rem\r\n    }\r\n  }\r\n\r\n  .card__content {\r\n    font-size: 1rem;\r\n    line-height: 1.25;\r\n    padding: 1rem 1rem 4rem;\r\n    border-top: 6px solid #47888E;\r\n    display: flex;\r\n    flex-direction: column;\r\n    order: 2\r\n  }\r\n\r\n  @media (min-width:62em) {\r\n    .card__content {\r\n      font-size: 1rem;\r\n      padding: 1rem 2rem 4rem\r\n    }\r\n  }\r\n\r\n  .card__content p {\r\n    margin: 0 0 .75rem\r\n  }\r\n\r\n  .card__tag {\r\n    font-family: Montserrat, Arial, sans-serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    font-weight: 600;\r\n    order: 1\r\n  }\r\n\r\n  .card__date {\r\n    order: 2\r\n  }\r\n\r\n  .card__date, .card__tag {\r\n    font-size: .875rem;\r\n    line-height: 1.25\r\n  }\r\n\r\n  @media (min-width:62em) {\r\n    .card__date, .card__tag {\r\n      font-size: .875rem\r\n    }\r\n  }\r\n\r\n  .card__copy, .card__icon, .card__title {\r\n    order: 3\r\n  }\r\n\r\n  .card__icon {\r\n    margin: 1rem 0 0;\r\n    bottom: 1rem;\r\n    position: absolute;\r\n    width: 1rem;\r\n    height: 1rem\r\n  }\r\n\r\n  @media (min-width:48em) {\r\n    .card__icon {\r\n      width: 1.25rem;\r\n      height: 1.25rem\r\n    }\r\n  }\r\n\r\n  .card__link {\r\n    text-decoration: none;\r\n    color: #002664\r\n  }\r\n\r\n  .card__link:after {\r\n    z-index: 100;\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0\r\n  }\r\n\r\n  .card__link:focus, .card__link:hover {\r\n    text-decoration: underline\r\n  }\r\n\r\n  .card__link:focus {\r\n    outline: none\r\n  }\r\n\r\n  .card__image-area {\r\n    order: 1;\r\n    height: 12.5rem;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .card__image {\r\n    position: relative;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%,-50%);\r\n    width: 100%;\r\n    height: 100%;\r\n    /*object-fit: contain;*/\r\n  }\r\n\r\n  .card--headline .card__title {\r\n    font-size: 1.625rem;\r\n    line-height: 1.25\r\n  }\r\n\r\n  @media (min-width:62em) {\r\n    .card--headline .card__title {\r\n      font-size: 1.75rem\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
